import React, { useState, useEffect, useRef } from 'react';
import './Projects.css'; // Import the CSS file with the styles
import VanillaTilt from 'vanilla-tilt';

const cardsData = [
    { id: 1, title: 'EpilepsyShield', content: 'A chrome extension that detects flashing lights from YouTube videos and skips those segments to help people suffering from Photosensitive Epilepsy enjoy the videos.', tech: 'HTML - CSS - JS - Python', link: 'https://github.com/Rishabh-Tripathi1/EpilepsyShield' },
    { id: 2, title: 'CodeScanner', content: 'CodeScanner is a mobile app for developers and coding enthusiasts, allowing easy digitization of handwritten code using OCR technology and seamless in-app compilation for efficient coding.', tech: 'AS: Java - OCR', link: 'https://github.com/Rishabh-Tripathi1/CodeScanner' },
    { id: 3, title: 'Wastify', content: 'The Waste Classification App is a web application that utilizes Artificial Intelligence (AI) to identify and classify waste from five categories: plastic bottles, wood, paper, e-waste, and plastic bags.', tech: 'AS: Java - Python', link: 'https://github.com/Rishabh-Tripathi1/waste-classification' },
    { id: 4, title: 'AI Customer Bot', content: 'A Documentation Chatbot using React.js integrated with Large Language Models and MongoDB for data storage, with Vector Similarity Search for efficient data extraction to enhance user interaction and access to documentation.', tech: 'React.js - Python - LLM', link: '' },

];

const Card = ({ title, content, tech, link }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const tiltRef = useRef();

    useEffect(() => {
        const tiltOptions = {
            max: 15,
            speed: 100,
            resetStart: true,
        };
        VanillaTilt.init(tiltRef.current, tiltOptions);

        return () => {
            tiltRef.current.vanillaTilt.destroy();
        };
    }, []);

    const handleCardClick = () => {
        setIsExpanded((prevState) => !prevState)
    };

    return (
        <div className='elements'>
            <div ref={tiltRef} className={`card ${isExpanded ? 'expanded' : ''}`} >
                <h3 className='card-head'>{title}</h3>
                <h3 className='card-body'>{tech}</h3>
                <a className="button-link2" onClick={handleCardClick}>
                    See More
                </a>
                {isExpanded && (
                    <div className="expanded-card-overlay">
                        <div className="expanded-card">
                            <span className="close-button">
                                &times;
                            </span>
                            {/* <h3 className='ecard-head'>{tech}</h3> */}
                            <p className='ecard-body'>{content}</p>
                            <a href={link} className="button-link">
                                GitHub
                            </a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const Project = () => {


    return (
        <div className='project'>
            <div className='pro-title'>
                <div className='line'></div>
                <h2 className='pr'>&nbsp;&nbsp;Projects<span className='dot'>.&nbsp;&nbsp;</span></h2>
                <div className='line'></div>
            </div>
            <div className="elements">
                {cardsData.map((card) => (
                    <Card key={card.id} title={card.title} content={card.content} tech={card.tech} link={card.link} />
                ))}
            </div>
            <div className='pro-foot'>
                <h2 className='foot-head'><a href="https://github.com/Rishabh-Tripathi1?tab=repositories" className='git-link'>more projects<span className='dot'>.</span></a></h2>
            </div>
        </div >
    );
};

export default Project;
